import { gql } from 'apollo-angular';

export const QUALTRICS_SURVEY_FEEDBACK_QUESTIONS_DETAILS = gql`
  query SurveyInfo {
    surveyInfo {
      isSuccess
      message
      errorCode
      data {
        id
        surveyName
        surveyType
        qualtricsSurveyId
        versionNumber
        surveyDetails
        __typename
      }
      __typename
    }
  }
`;
